module.exports = __webpack_public_path__ + "img/grey-academy-i.28c5a4a0.png";